import React from 'react'
import Form, { Input } from '#Form'
import Dialog from '#Dialog'

const EditForm = ({ _id, phase }) => {

	const formDef = {
		_id,
		callSet: _id ? "ops/waste/update" : "ops/waste/create",
		callGet: _id && "ops/waste/get",
		extraData: { phase },
	}

	return (
		<Form {...formDef}>
			<Input label="Nome" name="label" />
		</Form>
	)
}

const RecipePhaseWasteEdit = ({ _id, phase, open, handleClose, handleRefresh, handleRowRefresh }) => {
	const triggerClose = () => {
		handleClose()
		_id ? handleRowRefresh() : handleRefresh()
	}

	const title = (_id ? 'Modifica' : 'Crea') + ' scarto'
	return (
		<Dialog
			handleClose={triggerClose}
			open={open}
			title={title}
			width="md"
		>
			<EditForm _id={_id} phase={phase} />
		</Dialog>
	)
}
export default RecipePhaseWasteEdit
